import * as React from "react";
import {Chip} from "@mui/material";
import {useTranslation} from "react-i18next";
import {JobPosition} from "../../../hooks/useJobPositions";

/**
 * Status pill used by the desktop list, details panel and mobile cards:
 * a dot + Active/Inactive label, tinted by the approval state (rejected/closed override the colour).
 */
export default function JobStatusChip({row}: Readonly<{ row: Pick<JobPosition, "active" | "status"> }>): React.ReactElement {
    const {t} = useTranslation();
    const status = row.status?.toUpperCase();
    let color: "success" | "error" | "warning" | "default" = row.active ? "success" : "default";
    if (status === "REJECTED") color = "error";
    else if (status === "CLOSED") color = "warning";

    return (
        <Chip
            size="small"
            color={color}
            variant="outlined"
            label={row.active ? t("common.status.active") : t("common.status.inactive")}
            icon={<span style={{width: 8, height: 8, borderRadius: "50%", background: "currentColor"}}/>}
            sx={{
                fontWeight: 500,
                border: "none",
                bgcolor: (theme) => color === "default" ? theme.palette.action.hover : `${theme.palette[color].main}1F`,
                "& .MuiChip-icon": {ml: 1, mr: -0.25},
            }}
        />
    );
}
